import { defaultConfig } from './config'

export function formatCurrency(value, currency = defaultConfig.currency) {
    const formats = {
        EUR: () => {
            return `${new Intl.NumberFormat('lt-LT', {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)} €`
        },
        USD: () => {
            return `$${new Intl.NumberFormat('en-US', {
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value)}`
        },
    }

    return formats[currency]?.() ?? `${value} ${currency}`
}

export function isPreferedSeller(facet) {
    return facet?.name?.toLowerCase() === "cratejoy's best";
}
